import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircle, Clock, Loader2 } from 'lucide-react';

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ProactivityPrompt = ({ request, onAccept, onDecline, loading = false }) => {
  const subtitle = [
    request.project_name ? `Projet ${request.project_name}` : null,
    formatDate(request.created_at),
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="flex-1 rounded-2xl border border-indigo-200/80 bg-gradient-to-br from-white via-white to-indigo-50/70 p-4 shadow">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-indigo-500">Nexus</p>
          <h4 className="mt-1 text-sm font-bold text-slate-900">{request.objective_name}</h4>
          {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
        </div>
        <span className="rounded-full bg-indigo-100 px-2.5 py-1 text-[11px] font-semibold uppercase text-indigo-600">
          Nexus
        </span>
      </div>

      <p className="mt-3 text-sm text-slate-700 whitespace-pre-line">{request.message}</p>
      {request.task_name && (
        <p className="mt-2 text-xs text-slate-500">
          <Clock className="mr-1 inline h-3 w-3 text-indigo-400" />
          Dernière tâche cochée&nbsp;: <span className="font-medium text-slate-700">{request.task_name}</span>
        </p>
      )}

      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onAccept}
          disabled={loading}
          className="inline-flex flex-1 items-center justify-center rounded-full bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Traitement…
            </>
          ) : (
            <>
              <CheckCircle className="mr-2 h-4 w-4" />
              Oui, clôturer
            </>
          )}
        </button>
        <button
          type="button"
          onClick={onDecline}
          disabled={loading}
          className="inline-flex flex-1 items-center justify-center rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Pas maintenant
        </button>
      </div>
    </div>
  );
};

ProactivityPrompt.propTypes = {
  request: PropTypes.shape({
    id: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    objective_name: PropTypes.string.isRequired,
    project_name: PropTypes.string,
    task_name: PropTypes.string,
    created_at: PropTypes.string,
  }).isRequired,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ProactivityPrompt;
